var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5001 82.9347C79.8823 82.9347 83.4347 79.3822 83.4347 75C83.4347 70.6179 79.8823 67.0654 75.5001 67.0654C71.1179 67.0654 67.5655 70.6179 67.5655 75C67.5655 79.3822 71.1179 82.9347 75.5001 82.9347Z",
    fill: "#61DAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 91.2563C99.0141 91.2563 118.076 83.9781 118.076 75C118.076 66.022 99.0141 58.7438 75.5 58.7438C51.986 58.7438 32.9241 66.022 32.9241 75C32.9241 83.9781 51.986 91.2563 75.5 91.2563Z",
    stroke: "#61DAFB",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4217 83.1281C73.1787 103.492 89.0128 116.361 96.788 111.872C104.563 107.383 101.335 87.2356 89.5784 66.8719C77.8214 46.5081 61.9873 33.6391 54.2121 38.1281C46.4368 42.6172 49.6647 62.7644 61.4217 83.1281Z",
    stroke: "#61DAFB",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4217 66.8718C49.6646 87.2356 46.4368 107.383 54.212 111.872C61.9873 116.361 77.8213 103.492 89.5784 83.1281C101.335 62.7643 104.563 42.6171 96.788 38.1281C89.0127 33.639 73.1787 46.508 61.4217 66.8718Z",
    stroke: "#61DAFB",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactJs);
export default __webpack_public_path__ + "static/media/ReactJS.339d0f9a2910c4d6d66d87b1ba449c4b.svg";
export { ForwardRef as ReactComponent };